import {Account} from '../../shared/models/account.model';
import {Action} from '@ngrx/store';
import {AccountListsActions, ADD_ACCOUNT} from "./accounts.actions";
import * as AcccountActions from './accounts.actions';

//https://stackoverflow.com/questions/45587050/ngrx-store-resets-after-browser-refresh-how-to-make-the-application-preserve-th
//https://github.com/btroncone/ngrx-store-localstorage


export interface State {
  accounts: Account[];
  editAccount: Account;
  editAccountIndex: number;
  loading: boolean;
  error: null | string;
}

const initialState: State = {
  accounts: [],
  editAccount: null,
  editAccountIndex: -1,
  loading: false,
  error: null
};


export function accountListReducer(state: State = initialState,
                                   action: AcccountActions.AccountListsActions
) {
  switch (action.type) {
    case AcccountActions.LOADING: //THIS IS GET REQUEST FOR LIST
      console.log('FROM REDUCER LOADING');
      return {
        ...state,
        loading: true,
        error: null
      };
    case AcccountActions.LOAD_ACCOUNTS: //THIS IS GET REQUEST FOR LIST
      console.log('FROM REDUCER LOAD_ACCOUNTS');
      return {
        ...state,
        loading: true,
        error: null
      };
    case AcccountActions.LOAD_ACCOUNTS_ERROR: //THIS IS GET REQUEST FOR LIST
      return {
        ...state,
        accounts: [...state.accounts],
        loading: false,
        error: action.payload
      };
    case AcccountActions.LOAD_ACCOUNT:
      return {
        ...state,
      };
    case AcccountActions.LOAD_ACCOUNT_ERROR: //THIS IS GET REQUEST FOR LIST
      return {
        ...state,
        accounts: [...state.accounts],
        loading: false,
        error: action.payload
      };
    case AcccountActions.LOAD_ADD_ACCOUNT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case AcccountActions.LOAD_ADD_ACCOUNT_ERROR:
      console.log('ERROR IN  REDUCER->LOAD_ADD_ACCOUNT_ERROR', action.payload);
      return {
        ...state,
        accounts: [...state.accounts],
        loading: false,
        error: action.payload
      };
    case AcccountActions.LOAD_UPDATE_ACCOUNT:
      console.log('LOAD_UPDATE_ACCOUNT');
      return {
        ...state,
      };
    case AcccountActions.LOAD_UPDATE_ACCOUNT_ERROR:
      console.log('LOAD_UPDATE_ACCOUNT_ERROR');
      return {
        ...state,
      };
    case AcccountActions.LOAD_DELETE_ACCOUNT:
      return {
        ...state,
      };
    case AcccountActions.ADD_ACCOUNT:
      console.log(' !!!!! ADD_ACCOUNT');
      return {
        ...state,
        accounts: [...state.accounts, action.payload],
        loading: false,
        error: null
      };
    case AcccountActions.ADD_ACCOUNTS:
      console.log('FROM REDUCER ADD_ACCOUNTS');
      return {
        ...state,
        accounts: [...state.accounts, ...action.payload],
        loading: false,
        error: null
      };
    case AcccountActions.UPDATE_ACCOUNT:
      console.log('UPDATE_ACCOUNT');
      const account = state.accounts[action.payload.index];
      const updatedAccount = {
        ...account,
        ...action.payload.account
      };
      const updatedAccounts = [...state.accounts];
      updatedAccounts[action.payload.index] = updatedAccount;
      return {
        ...state,
        accounts: updatedAccounts
      };
    case AcccountActions.DELETE_ACCOUNT:
      return {
        ...state,
        accounts: state.accounts.filter((account, index) => {
          return index !== action.payload;
        })
      };
    case AcccountActions.START_EDIT_ACCOUNT:
      return {
        ...state,
        editAccount: {...state.accounts[action.payload]},
        editAccountIndex: action.payload
      };
    case AcccountActions.STOP_EDIT_ACCOUNT:
      return {
        ...state,
        editAccount: null,
        editAccountIndex: -1
      };
    case AcccountActions.RESET_ACCOUNT:
      return {
        ...state,
        accounts: [] //[action.payload]
      };
    default:
      return state;
    // if (retrieveState()) {
    //   var newState = JSON.parse(retrieveState())
    //   return newState
    // }
    // else {
    //   return state;
    // }

  }
};


//
// export function accountReducer() {
//   return function (state: AccountState, action: AccountActions) {
//     switch (action.type) {
//       case AccountActionTypes.LoadAccountsSuccess: {
//         return {
//           ...state,
//           accounts: action.payload,
//           error: null,
//           loading: false,
//         };
//       }
//       case AccountActionTypes.LoadAccountsFailure: {
//         return {
//           ...state,
//           error: action.payload,
//           loading: false,
//         };
//       }
//       case AccountActionTypes.LoadAccounts: {
//         return {
//           ...state,
//           loading: true,
//         };
//       }
//       default: {
//         return state;
//       }
//     }
//   };
